export enum MobilePhotoAction {
    NONE = 0,
    TAKE_PHOTO = 1,
    UPLOAD_PHOTO = 2
}